import React from 'react'
import Footer from '../components/Footer'

import gal1 from '../images/gal1.jpg';
import gal2 from '../images/gal2.jpg';
import gal3 from '../images/gal3.jpg';
import gal4 from '../images/gal4.jpg';
import gal5 from '../images/gal5.jpg';
import gal6 from '../images/gal6.jpg';

const Gallery = () => {
    return (
        <>

            <div className='headings'>
                <h3>gallery</h3>
            </div>



            <div className='gallery'>
                <img src={gal1} />
                <img src={gal2} />
                <img src={gal3} />
                
            </div>

             <div className='gallery'>
                
                <img src={gal4} />
                <img src={gal5} />
                <img src={gal6} />
            </div>

<br/>
            <Footer />
        </>
    )
}

export default Gallery